import AWS from "aws-sdk";

// https://cli.vuejs.org/guide/mode-and-env.html#environment-variables
AWS.config.update({
  region: "eu-central-1",
  credentials: {
    accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY_ID,
    IdentityPoolId: process.env.VUE_APP_AWS_IDENTITY_POOL_ID
  }
});

export default AWS;
